export const validateArtworkFields = (artworkState) => {
  const errors = [];
    
  if (!artworkState.artwork_about.artwork_artist) {
    errors.push({ element: 'artwork_artist', error_code: 'EMPTY_FIELD' });
  }

  if (!artworkState.artwork_about.artwork_type) {
    errors.push({ element: 'artwork_type', error_code: 'EMPTY_FIELD' });
  }

  if (!artworkState.artwork_about.artwork_title) {
    errors.push({ element: 'artwork_title', error_code: 'EMPTY_FIELD' });
  }

  if (artworkState.artwork_about.artwork_title.length < 3) {
    errors.push({ element: 'artwork_title', error_code: 'TITLE_TOO_SHORT' });
  }

  if (!artworkState.artwork_about.artwork_description) {
    errors.push({ element: 'artwork_description', error_code: 'EMPTY_FIELD' });
  }

  if (artworkState.artwork_about.artwork_description.length < 10) {
    errors.push({ element: 'artwork_description', error_code: 'DESCRIPTION_TOO_SHORT' });
  }

  if (!artworkState.artwork_about.artwork_medium) {
    errors.push({ element: 'artwork_medium', error_code: 'EMPTY_FIELD' });
  }

  if (artworkState.artwork_about.artwork_theme.length === 0) {
    errors.push({ element: 'artwork_theme', error_code: 'EMPTY_FIELD' });
  }

  if (artworkState.artwork_about.artwork_feeling.length === 0) {
    errors.push({ element: 'artwork_feeling', error_code: 'EMPTY_FIELD' });
  }

  if (artworkState.artwork_about.artwork_color.length === 0) {
    errors.push({ element: 'artwork_color', error_code: 'EMPTY_FIELD' });
  }

  if (!artworkState.artwork_about.artwork_year) {
    errors.push({ element: 'artwork_year', error_code: 'EMPTY_FIELD' });
  }

  if (!artworkState.artwork_about.artwork_size.length) {
    errors.push({ element: 'artwork_length', error_code: 'EMPTY_FIELD' });
  }

  if (!artworkState.artwork_about.artwork_size.height) {
    errors.push({ element: 'artwork_height', error_code: 'EMPTY_FIELD' });
  }

  if (artworkState.artwork_about.artwork_size.length <= 0) {
    errors.push({ element: 'artwork_length', error_code: 'INVALID_SIZE' });
  }

  if (artworkState.artwork_about.artwork_size.height <= 0) {
    errors.push({ element: 'artwork_height', error_code: 'INVALID_SIZE' });
  }

  if (!artworkState.artwork_about.artwork_currency) {
    errors.push({ element: 'artwork_currency', error_code: 'EMPTY_FIELD' });
  }

  if (!artworkState.artwork_about.artwork_price) {
    errors.push({ element: 'artwork_price', error_code: 'EMPTY_FIELD' });
  }

  if (artworkState.artwork_about.artwork_price <= 0) {
    errors.push({ element: 'artwork_price', error_code: 'INVALID_PRICE' });
  }

  if (artworkState.artwork_about.artwork_price <= 99) {
    errors.push({ element: 'artwork_price', error_code: 'INVALID_PRICE_LOWER_THAN_100' });
  }

  if (artworkState.artwork_about.artwork_price < (artworkState.artwork_about.artwork_original_price - (artworkState.artwork_about.artwork_original_price * 0.3))) {
    errors.push({ element: 'artwork_price', error_code: 'INVALID_PRICE_DOWNGRADE' });
  }

  return errors;
};